var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backview"},[_c('div',{staticClass:"username"},[_vm._v("HI!"+_vm._s(_vm.userName)+" Teacher")]),_c('div',{staticClass:"welcome"},[_vm._v("welcome !")])])}
var staticRenderFns = []

export { render, staticRenderFns }